import arrowImg from "../../../../picture/PlayLanguage.png";
import { useEffect, useRef, useState } from "react";

const meseciMap = {
  "01": "Januar",
  "02": "Februar",
  "03": "Mart",
  "04": "April",
  "05": "Maj",
  "06": "Jun",
  "07": "Jul",
  "08": "Avgust",
  "09": "Septembar",
  10: "Oktobar",
  11: "Novembar",
  12: "Decembar"
};

const CustomSelectSimple = ({
  allValues,
  selectedValue,
  onSelectChange,
  label,
  isMeseci
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const handleOpen = () => {
    if (!isOpen) {
      const rect = selectRef.current.getBoundingClientRect();
      optionsRef.current.style.width = rect.width + "px";
      optionsRef.current.style.top = rect.bottom + "px";
      optionsRef.current.style.left = rect.left + "px";
    }
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    if (onSelectChange) onSelectChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";
    optionsRef.current.style.top = rect.bottom + "px";
    optionsRef.current.style.left = rect.left + "px";

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef}>
      <div onClick={handleOpen} style={{ position: "relative" }}>
        <input
          type="text"
          value={isMeseci ? meseciMap[selectedValue] : selectedValue}
          readOnly
          placeholder={label}
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px",
            height: "40px",
            padding: "5px"
          }}
        />
        <div
          style={{
            width: "20px",
            position: "absolute",
            right: "0px",
            top: "12px"
          }}
        >
          <img
            src={arrowImg}
            alt=""
            className="profile-select-item-img"
            style={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
          />
        </div>
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "fixed",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          maxHeight: "200px",
          overflowY: "auto",
          width: "100%"
        }}
      >
        {allValues.map((value, index) => (
          <div
            key={value}
            onClick={() => handleSelect(value)}
            style={{
              wordBreak: "break-word",
              padding: "5px",
              borderBottom: "1px solid black",
              cursor: "pointer",
              backgroundColor: value == selectedValue ? "lightgrey" : "white",
              display: "flex",
              alignItems: "center",
              fontSize: "16px"
            }}
          >
            {isMeseci ? meseciMap[value] : value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSelectSimple;